import { IonIcon, IonText } from '@ionic/react';

import styles from '@components/explore/Explore.module.css';
import ExternalLink from '@components/typography/ExternalLink';
import useKeyboardFocus from '@hooks/useKeyboardFocus';
import { IconList, IconName } from '@utils/iconUtils';

type Props = {
  href: string;
  icon: IconName | undefined;
  onClick: () => void;
  text: string;
};

// Ion button is terrible with very long text, so this makes a custom tertiary button component for marketplace
const MarketplaceButton = ({ href, icon, onClick, text }: Props) => {
  const keyboardFocus = useKeyboardFocus();

  return (
    <ExternalLink
      className={`${styles.marketplaceButton} ${keyboardFocus ? styles.focus : ''}`}
      href={href}
      onClick={e => {
        e.stopPropagation();
        onClick();
      }}
      stylized={false}
    >
      <div className={styles.marketplaceButton}>
        {icon && <IonIcon className={styles.marketplaceButtonIcon} src={IconList[icon]} />}

        <IonText className={styles.marketplaceButtonText}>{text}</IonText>
      </div>
    </ExternalLink>
  );
};

export default MarketplaceButton;
